import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router';
import loader from '../../../assets/loading.gif';
import Notification from '../../Notification/Notification';
import PageHeader from '../../PageHeader/PageHeader';

class ConfirmPayNow extends React.Component {

  constructor(props) {
    super(props);
    this.submitOneOffPayment = this.submitOneOffPayment.bind(this);
    this.state = {
      payNowPending: false
    };
  }

  componentWillMount() {
    // forces redirect to /login if unauthorized
    this.props.checkSession();
  }

  submitOneOffPayment() {
    this.setState({ payNowPending: true });
    this.props.submitPayNow().then(
      () => { /* the submitPayNow action will redirect to dashboard on success */ },
      () => this.setState({ payNowPending: false })
    );
  }

  render() {
    return (
      <main>
        <PageHeader title={'Pay Now Confirmation'} />
        <section className="section-half-margin">
          { this.props.payNowError !== '' &&
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <Notification>
                    {/* {this.props.payNowError}<br /> */}
                    Please try again, or <Link to="/dashboard">return to the
                    dashboard</Link> to update your credit card.
                  </Notification>
                </div>
              </div>
            </div>
          }
          <div className="container gray-container">
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <h4 className="gray-container-title heading-underline">Amount to be paid</h4>
                <p className="gray-container-left-content bold text-small">
                  Total
                  <span className="gray-container-value float-right text-medium">
                    ${this.props.customerInfo.accountBalance}
                  </span>
                </p>
                <p className="gray-container-left-content">
                  Credit card ending
                  <span className="float-right">**** **** **** {this.props.customerInfo.currentCardLastDigits}</span>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 relative">
                <div className="gray-container-centered">
                  <Button
                    className="gray-container-centered-button"
                    onClick={() => this.submitOneOffPayment()}
                    disabled={this.state.payNowPending}
                  >
                    {this.state.payNowPending ?
                      <img
                        src={loader}
                        height="20"
                        alt="Loading..."
                        role="presentation"
                      /> : 'Confirm'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 centre">
                <Link className="underline" to="/dashboard">Cancel</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

ConfirmPayNow.propTypes = {
  checkSession: PropTypes.func,
  submitPayNow: PropTypes.func,
  customerInfo: PropTypes.object,
  payNowError: PropTypes.string
};

export default ConfirmPayNow;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/ConfirmPayNow/ConfirmPayNow.js
 **/